import { useContext } from "react"
import { AuthContext } from "../context"

const useEventActions = ({ event }) => {

  const { authUser } = useContext(AuthContext)

  const isEventParticipant = (currentEvent = event) => {
    if (!authUser) return false
    if (!currentEvent) return false
    if (!currentEvent.participants) return false
    if (currentEvent.participants.find(pId => pId === authUser.uid)) {
      return true
    }
    return false
  }
  
  const isEventOrganiser = (currentEvent = event) => {
    if (!authUser) return false
    if (!currentEvent) return false
    if (!currentEvent.organiser_id) return false
    return currentEvent.organiser_id === authUser.uid
  }

  const isEventDriver = (currentEvent = event) => {
    if (!authUser) return false
    if (!currentEvent) return false
    if (!currentEvent.vehicles) return false
    return currentEvent.vehicles.some(vehicle => {
      return vehicle.driver_id === authUser.uid
    })
  }

  const isVehicleDriver = (vehicle) => {
    if (!authUser) return false
    if (!vehicle) return false
    return vehicle.driver_id === authUser.uid
  }

  const myEventVehicle = (currentEvent = event) => {
    if (!authUser) return false
    if (!currentEvent) return false
    if (!currentEvent.vehicles) return false
    return currentEvent.vehicles.find(vehicle => {
      return vehicle.driver_id === authUser.uid
    })
  }

  const vehiclePassengers = (vehicle, journeyType) => {
    return (vehicle.passengers || []).filter(p => (!journeyType || p[journeyType]))
  } 

  const isVehiclePassenger = (vehicleIndex, journeyType, currentEvent = event) => {
    return myVehiclePassengers(vehicleIndex, journeyType, currentEvent).length > 0
  }

  const myVehiclePassengers = (vehicleIndex, journeyType, currentEvent = event) => {
    if (!authUser) return []
    if (!currentEvent) return []
    if (!currentEvent.vehicles) return []
    
    if(vehicleIndex === -1) {
      return currentEvent.vehicles.reduce((acc, vehicle) => {
        acc.push(...vehiclePassengers(vehicle, journeyType))
        return acc
      }, []).filter(p => p.user_id === authUser.uid)
    }
    return vehiclePassengers(currentEvent.vehicles[vehicleIndex], journeyType).filter(p => p.user_id === authUser.uid)
  }

  const isOnWaitlist = (currentEvent = event) => {
    return myWaitlistPassengers(currentEvent).length > 0
  }

  const myWaitlistPassengers = (currentEvent = event) => {
    if (!authUser) return []
    if (!currentEvent) return []
    if (!currentEvent.waitlist) return []
    return currentEvent.waitlist.filter(p => p.user_id === authUser.uid)
  }


  return {
    isEventParticipant,
    isEventOrganiser,
    isEventDriver,
    myEventVehicle,
    isVehiclePassenger,
    myVehiclePassengers,
    vehiclePassengers,
    isOnWaitlist,
    myWaitlistPassengers,
    isVehicleDriver
  }
}

export default useEventActions
